export enum TravelResignationBannerEnum {
  Body = 'Odzyskaj środki za odwołany wyjazd.\nUbezpiecz koszty rezygnacji.',
  ButtonLabel = 'Zobacz szczegóły',
  Title = 'A co, jeśli nie wyjedziesz?',
  Url = 'https://sprzedaz.wiener.pl/rezygnacjazimprezy/r/mubi_koszty_rezygnacji',
}
